import { t } from '@hefe/i18n';
import {
  EventHelpout,
  EventHelpoutEventableType,
  EventHelpoutEventableTypeEnum,
  SelectOption,
} from '@hefe/models';
import { Select } from 'antd';
import { useMemo, useState } from 'react';
import { useAppDispatch } from '../../../../store/store';
import InlineEditInput from '../../../core/components/inline-edit-input/inline-edit-input.component';
import {
  BasketballPracticesActions,
  BasketballTeamGameActions,
  EventHelpoutsApi,
} from '@hefe/store';

interface EventTeamHelpoutsComponentProps {
  helpouts: EventHelpout[];
  eventType: EventHelpoutEventableTypeEnum;
  eventId: number;
  teamId?: number;
}

export default function EventTeamHelpoutsComponent(
  props: EventTeamHelpoutsComponentProps
) {
  const { helpouts } = props;

  const dispatch = useAppDispatch();

  const [getHelpoutables, { data: helpoutables, isFetching }] =
    EventHelpoutsApi.useLazyFetchPossibleHelpoutablesQuery();

  const [saving, setSaving] = useState(false);

  const text = useMemo(() => {
    if (!helpouts || helpouts.length === 0) {
      return t('helpouts.none');
    }

    return t('helpouts.number_of_helpouts', { count: helpouts.length });
  }, [helpouts]);

  const loadHelpoutables = (editMode: boolean) => {
    if (!editMode) {
      return;
    }

    getHelpoutables(undefined, true);
  };

  const saveHelpouts = (value: string[]) => {
    if (props.eventType === EventHelpoutEventableType.BASKETBALL_TEAM_GAME) {
      setSaving(true);
      dispatch(
        BasketballTeamGameActions.setBasketballTeamGameHelpouts({
          team_game_id: props.eventId,
          helpoutables: value,
        })
      )
        .unwrap()
        .catch(() => undefined)
        .finally(() => setSaving(false));
    } else if (
      props.eventType === EventHelpoutEventableType.BASKETBALL_PRACTICE
    ) {
      if (!props.teamId) {
        return;
      }

      setSaving(true);
      dispatch(
        BasketballPracticesActions.setBasketballPracticeHelpouts({
          practice_id: props.eventId,
          team_id: props.teamId,
          helpoutables: value,
        })
      )
        .unwrap()
        .catch(() => undefined)
        .finally(() => setSaving(false));
    }
  };

  return (
    <InlineEditInput
      highlightingMode="self"
      component={Select}
      value={helpouts.map((helpout) => helpout.helpoutable.value)}
      text={text}
      loading={saving}
      onOk={(value) => saveHelpouts(value)}
      onModeChange={(editMode) => loadHelpoutables(editMode)}
      componentProps={{
        options: helpoutables,
        mode: 'multiple',
        showSearch: true,
        loading: isFetching,
        filterOption: (input: string, option: SelectOption) =>
          option?.label?.toLowerCase().includes(input?.toLowerCase()),
      }}
    />
  );
}
